import React from "react";
import { BaseInput } from "src/components/BaseInput";
import { Control, Controller } from "react-hook-form";
import { ContractGroupModel, ContractGroupStatus } from "src/api/contractGroup/contractgroup-type";
import { CONTRACT_GROUP_STATUS_OPTIONS } from "../../contractgroup-constant";

type Props = {
  control: Control<ContractGroupModel>;
  groupStatus: ContractGroupStatus;
  contractSubjectInfo: {
    primaryOrgName: string;
    primaryCount: number;
    otherCount: number;
    totalCount: number;
  } | null;
};

const ContractGroupInfoForm = ({ control, contractSubjectInfo, groupStatus }: Props) => {
  return (
    <article className="contents-container__wrap-article">
      <div className="contents-container__sub-title">
        <h2>기본정보</h2>
      </div>
      <section className="contents-container__grid">
        <div className="contents-container__grid-index">
          <p>상태</p>
        </div>
        <div className="contents-container__grid-contents">
          <div className="minmax240">
            <span>{groupStatus ? CONTRACT_GROUP_STATUS_OPTIONS.find((option) => option.value === groupStatus)?.label : "-"}</span>
          </div>
        </div>
      </section>
      <section className="contents-container__grid">
        <div className="contents-container__grid-index">
          <p className="required">계약그룹명</p>
        </div>
        <div className="contents-container__grid-contents">
          <div className="minmax240">
            <Controller
              control={control}
              name="groupName"
              rules={{ required: { value: true, message: "필수입력 항목입니다." } }}
              render={({ field: { onChange, value, name }, fieldState: { error } }) => (
                <BaseInput name={name} placeholder="계약그룹명을 입력해주세요" onChange={onChange} value={value} errorText={error?.message} />
              )}
            />
          </div>
        </div>
      </section>
      <section className="contents-container__grid">
        <div className="contents-container__grid-index">
          <p>계약자 (법인명/상호)</p>
        </div>
        <div className="contents-container__grid-contents">
          <div className="minmax240">
            {contractSubjectInfo ? (
              <span>
                {contractSubjectInfo.primaryOrgName}
                {contractSubjectInfo.otherCount > 0 && ` 외 ${contractSubjectInfo.otherCount}개`}
              </span>
            ) : (
              <span>-</span>
            )}
          </div>
        </div>
      </section>
    </article>
  );
};

export default ContractGroupInfoForm;
